module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      "placeholder": "Opens at"
    },
    model: {
      value: (_vm.value.opens),
      callback: function($$v) {
        _vm.$set(_vm.value, "opens", $$v)
      },
      expression: "value.opens"
    }
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      "placeholder": "Closes at"
    },
    model: {
      value: (_vm.value.closes),
      callback: function($$v) {
        _vm.$set(_vm.value, "closes", $$v)
      },
      expression: "value.closes"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d098cfcc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/TimeRangePicker.vue
// module id = 377
// module chunks = 4